import { __, getID } from "src/libs/utilities"
import { IPanelLayout } from "../views/UIX/interface"

function initPanel (): IPanelLayout{
    return {
        panelDatas: [],
        panels: [ ],
        consoles: [ 
            {
                id: getID("console"),
                width: 270,
                isOpen: true,
                panels: [
                    {
                        id: getID("sections"),
                        x: 110,
                        y: 300,
                        w: 350,
                        h: 350,
                        activeId: "sections",
                        isOpen: true,
                        isTread: true,
                        panelDatas: [
                            {
                                id: "sections", 
                                title: __("Sections"),
                                icon: "/assets/img/landing/layers.svg"
                            },
                            {
                                id: "landing-settings", 
                                title: __("Settings"),
                                icon: "/assets/img/landing/landing-settings.svg", 
                            },
                        ]
                    },
                    {
                        id: getID("meat"),
                        x: 230,
                        y: 270,
                        w: 350,
                        h: 320,
                        isOpen: true,
                        isTread: true,
                        panelDatas: [
                            {
                                title: __( `Meat`),
                                icon: "/assets/img/landing/meat.svg", 
                                id: "meat"
                            },
                            {
                                title: __( `Float`),
                                icon: "/assets/img/landing/float.svg",
                                id: "float"
                            },
                            {
                                title: __( `Title`),
                                icon: "/assets/img/landing/html.svg",
                                id: "title"
                            },
                            {
                                title: __( `Background`),
                                icon: "/assets/img/landing/background.svg",
                                id: "background"
                            },
                            {
                                title: __( `Delimiter`),
                                icon: "/assets/img/landing/divide.svg",
                                id: "delimiter"
                            },
                        ]
                    }, 
                    {
                        id: getID("fill"),
                        x: 230,
                        y: 270,
                        w: 350,
                        h: 320,
                        isOpen: true,
                        isTread: true,
                        panelDatas: [
                            {
                                title: __( `FILL`),
                                icon: "/assets/img/landing/fill.svg", 
                                id: "fill"
                            },
                            {
                                title: __( `Border`),
                                icon: "/assets/img/landing/borders.svg", 
                                id: "border"
                            },
                        ]
                    },  
                ]
            },
            // {
            //     id: getID("console"),
            //     width: 270,
            //     isOpen: false,
            //     panels: [
            //         // {
            //         //     id: getID("cards"),
            //         //     x: 110,
            //         //     y: 300,
            //         //     w: 350,
            //         //     h: 350,
            //         //     activeId: "cards",
            //         //     isOpen: true,
            //         //     isTread: true,
            //         //     panelDatas: [
            //         //         {
            //         //             id: "cards", 
            //         //             title: __("Cards"),
            //         //             icon: "/assets/img/landing/cards-blank.svg"
            //         //         }, 
            //         //     ]
            //         // },
            //         {
            //             id: getID("card-template-preview"),
            //             x: 110,
            //             y: 300,
            //             w: 350,
            //             h: 350,
            //             activeId: "card-template-preview",
            //             isOpen: true,
            //             isTread: true,
            //             panelDatas: [ 
            //                 { 
            //                     id: "card-template-preview", 
            //                     title:`Card template preview`,
            //                     icon: "/assets/img/landing/table-layout.svg", 
            //                 },
            //             ]
            //         },
            //         {
            //             id: getID("card-template"),
            //             x: 110,
            //             y: 300,
            //             w: 350,
            //             h: 350,
            //             activeId: "card-template",
            //             isOpen: true,
            //             isTread: true,
            //             panelDatas: [ 
            //                 {
            //                     id: "card-template", 
            //                     title: __("Cards template"),
            //                     icon: "/assets/img/landing/card.svg", 
            //                 },
            //             ]
            //         },
            //         {
            //             id: getID("card-template"),
            //             x: 110,
            //             y: 300,
            //             w: 350,
            //             h: 350,
            //             activeId: "card-template",
            //             isOpen: true,
            //             isTread: true,
            //             panelDatas: [ 
            //                 { 
            //                     id: "single-field", 
            //                     title: __("Card field"),
            //                     icon: "/assets/img/landing/rows.svg", 
            //                 },
            //             ]
            //         },
            //     ]
            // }
        ],
        float:[
            {
                id: getID("Landing data"),
                x: 20,
                y: 60,
                w: 350,
                h: 90,
                activeId: "landing-data",
                isOpen: true,
                isTread: false,
                panelDatas: [
                    {
                        id: "landing-data", 
                        title: __("Landing data"),
                        icon: "/assets/img/landing/json-file.svg"
                    },
                ]
            },
            {
                id: getID("Animations"),
                x: 20,
                y: 260,
                w: 300,
                h: 250,
                activeId: "animation",
                isOpen: true,
                isTread: false,
                panelDatas: [
                    {
                        id: "animation", 
                        title: __("Animation"),
                        icon: "/assets/img/landing/animation.svg"
                    },
                ]
            },
            // {
            //     id: getID("transform"),
            //     x: getLandingContainer()?.getBoundingClientRect().width - 580,
            //     y: 20,
            //     w: 230,
            //     h: 290,
            //     activeId: "transform",
            //     isOpen: true,
            //     isTread: false,
            //     panelDatas: [
            //         {
            //             id: "transform", 
            //             title: __("Transform"),
            //             icon: "/assets/img/landing/transform.svg"
            //         },
            //     ]
            // },
        ],
    } as IPanelLayout
}

export default initPanel